import { ShopperSocialGroupJoinScanConfirmPage } from "./../shopper-social-group-join-scan-confirm/shopper-social-group-join-scan-confirm";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
} from "ionic-angular";
import { QRScanner, QRScannerStatus } from "@ionic-native/qr-scanner";
import { Storage } from "@ionic/storage";

@IonicPage()
@Component({
  selector: "page-shopper-social-group-join-scan",
  templateUrl: "shopper-social-group-join-scan.html",
})
export class ShopperSocialGroupJoinScanPage {
  scanSub: any;
  mission_id = "";
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private qrScanner: QRScanner,
    private loadingCtrl: LoadingController,
    private storage: Storage
  ) {
    this.mission_id = this.navParams.data.mission_id;
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    this.qrScanner
      .prepare()
      .then((status: QRScannerStatus) => {
        if (status.authorized) {
          // console.log('Camera Permission Given');
          this.scanSub = this.qrScanner.scan().subscribe((result: string) => {
            //  console.log('Scanned something', text);

            let loader = this.loadingCtrl.create({
              // content: "Loading Please Wait...",
              duration: 1000,
            });
            loader.present();

            this.navCtrl.push(ShopperSocialGroupJoinScanConfirmPage, {
              result,
              mission_id: this.mission_id,
            });

            this.qrScanner.hide();
            this.scanSub.unsubscribe();
          });

          this.qrScanner.show();
        } else if (status.denied) {
          console.log("Camera permission denied");
        } else {
          console.log("Permission denied for this runtime.");
        }
      })
      .catch((e: any) => console.log("Error is", e));
  }

  backPage() {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-social-group-join-scan/shopper-social-group-join-scan.ts